// NATIVE

// INSTALLED
import { checkingPreload, unCheckingPreload } from '../loading';
import { setMunicipalysRedux } from './municipalySlice';
import { setMunicipalysByIdService } from '../../services/municipaly.service';

// CUSTOM

export const setMunicipalyByDepartamentId = (departament_id: string): any => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());

    const response = await setMunicipalysByIdService(departament_id);

    if (response.ok) {
      dispatch(setMunicipalysRedux(response.data));
    } else {
    }

    dispatch(unCheckingPreload());
  };
};
